<template>
<div>
  <div v-if="receipt_data">
    <ReceiptPrint :document_data="receipt_data"/>
    <b-button v-if="$store.getters.isLoggedIn" class="print-button mt-1" variant="info" @click="$router.push('/')"><b-icon-arrow-left class="me-1"></b-icon-arrow-left>Назад</b-button>
    <b-button v-if="!$store.getters.isLoggedIn" class="print-button mt-1 ms-1" variant="info" @click="selectReceipt"><b-icon-receipt class="me-1"></b-icon-receipt>Выбрать</b-button>
    <b-button class="print-button mt-1 ms-1" variant="info" @click="getReceipt"><b-icon-arrow-repeat class="me-1"></b-icon-arrow-repeat>Обновить</b-button>
    <b-button class="print-button mt-1 ms-1" variant="primary" @click="print"><b-icon-printer class="me-1"></b-icon-printer>Печать</b-button>
  </div>
  <div v-else class="center-element">
<!--    <template v-if="!$store.state.show_invoice">-->
    <b-card-group deck align="center">
      <b-card style="max-width: 20rem;">
        <b-card-header class="border-bottom-0">Запрос квитанции</b-card-header>
        <b-card-text>
          <form @submit.prevent="getReceipt">
            <div>
              <b-form-input class="mt-1" type="text" name="account_id" v-model="form.account" placeholder="ЛС BTCom"/>
              <b-form-input class="mt-1" type="text" name="iin" v-model="form.iin" placeholder="ИИН"/>
            </div>
          </form>
          <p class="alert-danger" v-if="$store.state.login_error" id="error">{{$store.state.login_error}}</p>
        </b-card-text>
        <b-button variant="success" type="submit" @click.prevent.stop="getReceipt" :disabled="loading">
          <b-spinner small v-if="loading"></b-spinner>
          Запрос
        </b-button>
      </b-card>
    </b-card-group>
<!--    </template>-->
  </div>
</div>
</template>

<script>

import ReceiptPrint from "@/components/ReceiptPrint.vue";
import axios from "axios";
export default {
  name: "ReceiptView",
  components: {ReceiptPrint},
  data() {
    return {
      form:{
        account: '',
        iin:''
      },
      receipt_data: null,
      loading: false
    }
  },
  methods:{
    print: function (){window.print()},
    selectReceipt: function (){
      this.$store.dispatch('clearCurrentReceipt', {'account_id': this.form.account, 'iin': this.form.iin})
      this.$router.push('/invoice')
    },
    account: function (){
      return this.$store.state.current_receipt ? this.$store.state.current_receipt : null
    },
    getReceipt: function (){
      this.receipt_data = null;
      this.loading = true;
      axios.post('alm/receipt/current/', this.form).then((response) => {
        if (response.data.success){
          // success
          this.receipt_data = response.data.result
          this.loading = false;
        }
        else {
          this.loading = false;
        }
      })
      axios.post('ast/receipt/current/', this.form).then((response) => {
        if (response.data.success){
          this.receipt_data = response.data.result
          this.loading = false;
        }
        else {
          this.loading = false;
        }
      })
    },
    validAccount: function(){
      return true
    },
    isNumeric(str) {
      if (typeof str != "string") return false
      return !isNaN(str) && !isNaN(parseFloat(str))
    },
  },
  computed:{
    validBin(){
      if (this.isNumeric(this.form.iin)){return true} else {return false}
    },
  },
  mounted() {
    // console.log('#############333#####################################')
    // console.log(this.$store.state.topics)
    // console.log(this.$route.params)
    // console.log('#############333#####################################')
    if (this.$route.params.account_id){
      let params = {}
      if (this.isNumeric(this.$route.params.account_id)
          && this.$route.params.account_id.length >= 5
          && this.$route.params.account_id.length <= 7){
        params.account_id = this.$route.params.account_id
      }
      if (this.isNumeric(this.$route.params.period_id)
          && this.$route.params.period_id.length === 6){
        params.period_id = this.$route.params.period_id
      }
      if (JSON.stringify(params) !== '{}'){
        // setTimeout(this.$store.dispatch, 1000, 'getCurrentReceipt', params)
        axios.get('alm/receipt/', {params}).then((response) => {
          if (response.data.success){
            this.receipt_data = response.data.result
            this.loading = false;
          }
          else {
            this.loading = false;
          }
        })
        axios.get('ast/receipt/', {params}).then((response) => {
          if (response.data.success){
            this.receipt_data = response.data.result
            this.loading = false;
          }
          else {
            this.loading = false;
          }
        })
      }
    }

    if (this.$route.params.document_id){
      let params = {}
      console.log(params)
      params.document_id = this.$route.params.document_id

      if (JSON.stringify(params) !== '{}'){
        console.log('params', params)
        axios.get('alm/receipt/', {params}).then((response) => {
          if (response.data.success){
            this.receipt_data = response.data.result
            this.loading = false;
          }
          else {
            this.loading = false;
          }
        })
        axios.get('ast/receipt/', {params}).then((response) => {
          if (response.data.success){
            this.receipt_data = response.data.result
            this.loading = false;
          }
          else {
            this.loading = false;
          }
        })
      }
    }
    // console.log('#############################')
    // console.log(this.$route.params.document_id)
    // console.log(this.$route.params.account_id)
    // console.log(this.$store.getters.isLoggedIn)
    // console.log(this.$store.state.token)
    // console.log(typeof(this.$store.state.token))
    // console.log('4$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$')
    if (this.$route.params.account_id === undefined && this.$route.params.document_id === undefined && !this.$store.getters.isLoggedIn){
      // console.log('showinvoice')
      this.$store.dispatch("showInvoice");
    }
  }
}
</script>

<style scoped>

@media  print{
  @page { margin: 0; size: portrait !important;}
  body { margin: 1.6cm; }
  .print-button {display: none}
}

.center-element {
  position: fixed; /* or absolute */
  top: 20%;
  left: 42%;

}

</style>